import { Card, CardProps } from "antd";
import React, { PropsWithChildren } from "react";
import EmittedTitlesTable from "./EmittedTitlesTable";
import { EmittedTitlesTableProvider } from "../../../context/EmittedTitleTableContext";

export const EmittedTitlesTableCard = ({ children, cardProps }: { cardProps?: CardProps } & PropsWithChildren) => {
  return (
    <Card title={"Lista titoli arretrati"}>
      <EmittedTitlesTableProvider>
        <EmittedTitlesTable />
      </EmittedTitlesTableProvider>
    </Card>
  );
};